module.exports = __webpack_public_path__ + "img/FlexNGateImg1.f06cd654.png";